export interface UserIdentity {
  email: string
  name: string | null
  avatarUrl?: string | null
}

export function userDisplayName(user: UserIdentity | null): string {
  if (!user) return 'Signed-in user'
  return user.name?.trim() || user.email || 'Signed-in user'
}

export function userInitials(user: UserIdentity | null): string {
  if (!user) return '?'
  const name = user.name?.trim()
  if (name) {
    const initials = name
      .split(/\s+/)
      .map((part) => part[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase()
    if (initials) return initials
  }
  return (user.email[0] ?? '?').toUpperCase()
}
